export default __webpack_public_path__ + "static/media/alert-icon.f240db25.svg";